import {
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatTabGroup} from '@angular/material/tabs';
import {delay} from 'rxjs';

import {AssistantType} from './models/assistant.interface';
import {AiChatMarkdownService} from './services/ai-chat-markdown.service';
import {AiChatService} from './services/ai-chat.service';

@Component({
  selector: 'ai-chat-dialog',
  templateUrl: './ai-chat-dialog.component.html',
  styleUrls: ['./ai-chat-dialog.component.scss'],
  providers: [AiChatService, AiChatMarkdownService],
  encapsulation: ViewEncapsulation.None
})
export class AiChatDialogComponent implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);
  readonly apiError = this.aiChatService.apiError;
  readonly messages$ = this.aiChatService.messages$;
  readonly chatDate = this.aiChatService.chatDate;
  readonly assistants = this.aiChatService.assistants;
  readonly selectedAssistant = this.aiChatService.selectedAssistant;
  readonly isAssistantEnabled = this.aiChatService.isAssistantEnabled;

  public triggerResetInput = signal(false);

  private readonly SUPPORT_URL =
    'https://support.elements.cloud/en/articles/8704470-elementsgpt-org-copilot';

  @ViewChild('messageList') container: ElementRef;
  @ViewChild(MatTabGroup) assistantTabs: MatTabGroup;

  constructor(private aiChatService: AiChatService) {}

  ngOnInit() {
    this.initMessagesObserver();
  }

  ngOnDestroy() {
    this.aiChatService.cancelRunningChat();
    this.aiChatService.resetAssistant(null);
  }

  public resetChat(assistantType: AssistantType = this.selectedAssistant()) {
    this.triggerResetInput.set(!this.triggerResetInput());
    this.aiChatService.resetAssistant(assistantType);
  }

  public openSupportPage() {
    window.open(this.SUPPORT_URL, '_blank');
  }

  private initMessagesObserver() {
    this.aiChatService.messages$
      .pipe(takeUntilDestroyed(this.destroyRef), delay(300))
      .subscribe(() => this.scrollToTheBottom());
  }

  private scrollToTheBottom() {
    this.container.nativeElement.scrollTop = this.container.nativeElement.scrollHeight;
  }
}
